(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/router.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/router.js');
"use strict";


const Router = svs.app.ReactRouter.PlayerRouter;
const Route = svs.app.ReactRouter.Route;
const Gift = svs.tickets_giftshop.gift.Gift;
const Preview = svs.tickets_giftshop.preview.Preview;
const store = svs.tickets_giftshop.store;
const {
  routes: {
    GIFT_ROUTE,
    PREVIEW_ROUTE
  }
} = svs.tickets_giftshop.constants;
const TicketGiftshopRouter = () => React.createElement(ReactRedux.Provider, {
  store: store
}, React.createElement(Router, {
  basename: svs.core.data.baseUrl
}, React.createElement(Route, {
  component: Gift,
  exact: true,
  path: GIFT_ROUTE
}), React.createElement(Route, {
  component: Preview,
  exact: true,
  path: PREVIEW_ROUTE
})));
svs.tickets_giftshop.Router = TicketGiftshopRouter;

 })(window);